import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AuditEntityDataModel,
  AuditEvent,
  AuditEventEntityModel,
} from '../../models/audit/audit-event.model';
import { environment } from '../../../../environments/environment';
import { Pageable } from '../../models/common/pageable.model';

export interface AuditEventFilterModel {
  actionName?: string;
  actionNames?:string[];
  userName?: string;
  email?: string;
  startDate?: string; // ISO string for query param
  endDate?: string; // ISO string for query param
  success?: boolean;
  page: number;
  pageSize: number;
}

@Injectable({ providedIn: 'root' })
export class AuditService {
  private readonly baseUrl = `${environment.backend.url}/api/audit/event/v1`;

  constructor(private readonly http: HttpClient) {}

  getLastEvents(): Observable<AuditEvent[]> {
    return this.http.get<AuditEvent[]>(`${this.baseUrl}/last-events`);
  }

  getEvents(filter: AuditEventFilterModel, version = 'v1'): Observable<Pageable<AuditEvent>> {
    let params = new HttpParams()
      .set('page', String(filter.page))
      .set('pageSize', String(filter.pageSize));

    if (version === 'v2') {
      const actionNames =
        filter.actionNames && filter.actionNames.length > 0
          ? filter.actionNames
          : ['RectifyCustomer', 'PutUpdateShopSellerVtexSync','get dfdl', 'send dfdl','OrderCancelWorkflowIBMReprocessing','OrderCreateWorkflowIBMReprocessing','OrderWorkflowFeedbackIBMReprocessing'];

      actionNames.forEach((action) => {
        params = params.append('actionNames', action);
      });
    } else {
      if (filter.actionName) {
        params = params.set('actionName', filter.actionName);
      }
    }

    if (filter.actionName) params = params.set('actionName', filter.actionName);
    if (filter.userName) params = params.set('userName', filter.userName);
    if (filter.email) params = params.set('email', filter.email);
    if (filter.startDate) params = params.set('startDate', filter.startDate);
    if (filter.endDate) params = params.set('endDate', filter.endDate);
    if (filter.success !== undefined) params = params.set('success', String(filter.success));

    return this.http.get<Pageable<AuditEvent>>(`${this.baseUrl}/query`, { params });
  }

  getEventWithEntities(eventId: number): Observable<AuditEventEntityModel> {
    return this.http.get<AuditEventEntityModel>(`${this.baseUrl}/entities/${eventId}`);
  }

  getEventEntityData(entityAuditId: number) {
    return this.http.get<AuditEntityDataModel>(`${this.baseUrl}/entities/data/${entityAuditId}`);
  }
}
